<script setup lang="ts">
import Paginate from 'vuejs-paginate-next'
import { computed } from 'vue'
import { usePagination } from '~/composables/common/use-pagination'

const { onLoadPage } = usePagination()

const props = defineProps({
  total: {
    type: Number,
    default: 0
  },
  itemPerPage: {
    type: Number,
    default: 1
  },
  marginPages: {
    type: Number,
    default: 1
  },
  pageRange: {
    type: Number,
    default: 3
  },
  isParamInUrl: {
    type: Boolean,
    default: false
  },
  scrollToSection: {
    type: String,
    default: 'body' // scroll top = body or Section ID
  },
  className: {
    type: String,
    default: ''
  },
  currentPage: {
    type: Number
  }
})
const emit = defineEmits(['changePage'])
const totalPages = computed(() => {
  return Math.ceil(props.total / props.itemPerPage)
})
const changePage = (pageNumber: number): void => {
  onLoadPage(props.scrollToSection, props.isParamInUrl)
  emit('changePage', pageNumber)
}

const leftArrHtml = `
<span class="d-flex justify-content-center align-items-center">
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path d="M10.9538 12L15.027 16.073C15.1654 16.2115 15.2362 16.3856 15.2395 16.5953C15.2427 16.8048 15.1719 16.982 15.027 17.127C14.882 17.2718 14.7064 17.3443 14.5 17.3443C14.2937 17.3443 14.118 17.2718 13.973 17.127L9.47877 12.6328C9.38527 12.5391 9.31927 12.4403 9.28077 12.3365C9.24227 12.2327 9.22302 12.1205 9.22302 12C9.22302 11.8795 9.24227 11.7673 9.28077 11.6635C9.31927 11.5597 9.38527 11.4609 9.47877 11.3673L13.973 6.873C14.1115 6.73467 14.2856 6.66384 14.4953 6.6605C14.7048 6.65734 14.882 6.72817 15.027 6.873C15.1719 7.018 15.2443 7.19367 15.2443 7.4C15.2443 7.60634 15.1719 7.782 15.027 7.927L10.9538 12Z" fill="#393939"/>
  </svg>
</span>`

const rightArrHtml = `
<span class="d-flex justify-content-center align-items-center">
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path d="M13.4463 12L9.37301 7.92701C9.23468 7.78851 9.16385 7.61443 9.16051 7.40476C9.15735 7.19526 9.22818 7.01801 9.37301 6.87301C9.51801 6.72818 9.69368 6.65576 9.90001 6.65576C10.1063 6.65576 10.282 6.72818 10.427 6.87301L14.9213 11.3673C15.0148 11.4609 15.0808 11.5597 15.1193 11.6635C15.1578 11.7673 15.177 11.8795 15.177 12C15.177 12.1205 15.1578 12.2327 15.1193 12.3365C15.0808 12.4403 15.0148 12.5391 14.9213 12.6328L10.427 17.127C10.2885 17.2653 10.1144 17.3362 9.90476 17.3395C9.69526 17.3427 9.51801 17.2718 9.37301 17.127C9.22818 16.982 9.15576 16.8063 9.15576 16.6C9.15576 16.3937 9.22818 16.218 9.37301 16.073L13.4463 12Z" fill="#393939"/>
  </svg>
</span>`
</script>

<template>
  <Paginate
    :modelValue="currentPage"
    :pageCount="totalPages"
    :pageRange="pageRange"
    :marginPages="marginPages"
    :clickHandler="changePage"
    prev-class="page-item btn-paginate btn-paginate-prev"
    :prevText="leftArrHtml"
    next-class="page-item btn-paginate btn-paginate-next"
    :nextText="rightArrHtml"
    :containerClass="`pagination ${className}`"
    pageClass="page-item"
  />
</template>

<style lang="scss" scoped src="~scssAsset/components/common/pagination.scss"></style>
